import CloseIcon from "@mui/icons-material/Close";
import { FormHelperText, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect } from "react";
import "./style.scss";

export default function GenericDialog({
    open,
    setOpen,
    title = "",
    handleSave,
    children,
    saveButton = true,
    cancelButton = true,
    saveButtonText = "Guardar",
    cancelButtonText = "Cancelar",
    onClose = () => {},
    showCloseButton = true,
    dialogWidth = false,
    closeOnSave = false,
    disabledSaveButton = false,
    mandatoryText = true,
}) {
    useEffect(() => {
        if (closeOnSave) {
            handleClose();
        }
    }, [closeOnSave]);

    const handleClose = () => {
        setOpen(false);
        onClose();
    };

    const handleSaveClick = () => {
        handleSave();
        // if (closeOnSave) {
        //     handleClose();
        // }
    };

    const paperProp =
        dialogWidth === true
            ? {
                  style: {
                      width: "1000px",
                      maxWidth: "3000px",
                  },
              }
            : {};

    return (
        <div>
            <Dialog open={open} onClose={handleClose} PaperProps={paperProp}>
                {showCloseButton && (
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                <DialogTitle>
                    <strong>{title}</strong>
                </DialogTitle>
                <div>
                    {children}
                    {mandatoryText && (
                        <FormHelperText sx={{ padding: "0px 25px" }}>
                            * Campo obligatorio
                        </FormHelperText>
                    )}
                </div>
                {(cancelButton || saveButton) && (
                    <DialogActions>
                        {cancelButton && (
                            <Button onClick={() => handleClose()}>{cancelButtonText}</Button>
                        )}
                        {saveButton && (
                            <Button onClick={() => handleSaveClick()} disabled={disabledSaveButton}>
                                {saveButtonText}
                            </Button>
                        )}
                    </DialogActions>
                )}
            </Dialog>
        </div>
    );
}
